export default "__VITE_ASSET__DoCbJfZJ__"